import React from 'react';
import { motion } from 'framer-motion';

const AboutSection = () => {
    // Animation Variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.3
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.8,
                ease: [0.215, 0.61, 0.355, 1.0] // Cubic bezier for "Apple-like" smooth ease
            }
        }
    };

    return (
        <section id="about" className="relative py-32 bg-black text-white overflow-hidden">

            {/* 2. Background & Depth */}
            {/* Ambient Light - Radial Gradient */}
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-neutral-800/30 via-black to-black pointer-events-none" />

            {/* Technical Texture - Subtle Grid */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
                style={{
                    backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)',
                    backgroundSize: '40px 40px'
                }}
            />

            <div className="container mx-auto px-6 relative z-10">
                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-20%" }}
                    className="max-w-4xl mx-auto text-center" // 1. Typography: Constrained Width
                >
                    {/* 3. Micro-Copy & Alignment */}
                    <motion.div variants={itemVariants} className="flex items-center justify-center gap-4 mb-8">
                        <span className="w-8 h-[1px] bg-neutral-500 inline-block"></span> {/* Visual Anchor */}
                        <h2 className="text-xs font-bold tracking-[0.3em] text-neutral-400 uppercase">
                            Chi Siamo
                        </h2>
                        <span className="w-8 h-[1px] bg-neutral-500 inline-block"></span>
                    </motion.div>

                    {/* 1. Typography & Hierarchy - Fixed with text-balance */}
                    <motion.h2 variants={itemVariants} className="text-4xl md:text-6xl font-light leading-tight text-white mb-8 max-w-5xl mx-auto">
                        {/* Prima riga: Introduzione */}
                        <span className="block text-gray-300 mb-2">
                            Con un approccio specializzato in
                        </span>

                        {/* Seconda riga: I Servizi (Il Core) */}
                        {/* Usiamo text-balance per evitare che le parole si spezzino male */}
                        <span className="block font-semibold text-white mt-4 mb-6" style={{ textWrap: "balance" }}>
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-100 to-white">
                                Soluzioni di Copertura
                            </span>
                            {" "}e{" "}
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-blue-100">
                                Energia Sostenibile
                            </span>,
                        </span>

                        {/* Terza riga: La conclusione */}
                        <span className="block text-xl md:text-3xl text-gray-400 font-light mt-4">
                            siamo il partner di fiducia nella gestione <br className="hidden md:block" />
                            dell'involucro edilizio.
                        </span>
                    </motion.h2>

                    <motion.p variants={itemVariants} className="text-lg md:text-xl text-neutral-500 max-w-2xl mx-auto leading-relaxed font-light">
                        Vogliamo che i vostri spazi siano protetti e trasformati in risorse viventi del futuro.
                    </motion.p>
                </motion.div>
            </div>
        </section>
    );
};

export default AboutSection;
